import { useState, useRef, useEffect } from "react";
import { categories } from "@/mocks/categories";

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("");
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (cat: (typeof categories)[0]) => {
    setSelected(cat.name);
    setIsOpen(false);
    window.open(cat.url, "_blank", "noopener,noreferrer");
  };

  return (
    <section className="relative -mt-10 z-20 px-4 md:px-6">
      <div className="max-w-xl mx-auto">
        <div ref={dropdownRef} className="relative">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-full flex items-center justify-between gap-3 px-5 py-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all text-left cursor-pointer"
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className="ri-grid-line text-lg"></i>
              </div>
              <div>
                <span className={`text-sm font-medium block ${selected ? "text-foreground-950" : "text-foreground-400"}`}>
                  {selected || "Выберите категорию..."}
                </span>
                <span className="text-foreground-500 text-xs">14 категорий товаров</span>
              </div>
            </div>
            <div className={`w-8 h-8 flex items-center justify-center rounded-full bg-background-100 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}>
              <i className="ri-arrow-down-s-line text-foreground-600"></i>
            </div>
          </button>

          {isOpen && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 border border-background-200/70 rounded-xl overflow-hidden z-30 max-h-72 overflow-y-auto">
              {categories.map((cat) => (
                <button
                  key={cat.key}
                  onClick={() => handleSelect(cat)}
                  className="w-full flex items-center gap-3 px-5 py-3 text-left hover:bg-primary-50 transition-colors cursor-pointer border-b border-background-100 last:border-b-0"
                >
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                    <i className={`${cat.icon} text-sm`}></i>
                  </div>
                  <span className="text-sm text-foreground-800 font-medium whitespace-nowrap">{cat.name}</span>
                  <div className="ml-auto">
                    <i className="ri-arrow-right-up-line text-foreground-400 text-xs"></i>
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}